import React, { type PropsWithChildren } from 'react';
import { Breadcrumbs } from '@components/Blocks/Breadcrumbs';
import { SiteContentLayout } from '@components/Layouts/SiteContentLayout';
import { useProductsBreadcrumbsPath } from '@hooks/useProductsBreadcrumbsPath';
import { BaseContainer } from '@periodica/ui-kit';

export function ProductsContainer({ children }: PropsWithChildren) {
  const { breadcrumbsPath } = useProductsBreadcrumbsPath();
  return (
    <BaseContainer>
      <Breadcrumbs path={breadcrumbsPath} />
      <SiteContentLayout>{children}</SiteContentLayout>
    </BaseContainer>
  );
}
